import { Button } from '@chakra-ui/react'
import { RightCarouselButtonIcon } from 'assets/icons'

export const RightButtonIcon = ({ onClick, ...rest }) => {
  const {
    onMove,
    carouselState: { currentSlide, deviceType }
  } = rest

  return (
    <Button
      type="button"
      onClick={() => onClick()}
      style={{
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        position: 'absolute',
        right: '20px',
        zIndex: 1,
        fontSize: '50px',
        color: '#fff'
      }}
    >
      <RightCarouselButtonIcon />
    </Button>
  )
}
